import { useEffect, useState } from 'react';
import { subscribeToPush, sendSubscriptionToBackend, checkExistingSubscription } from '../utils/push-notifications';

export function usePushNotifications() {
  const [isSubscribed, setIsSubscribed] = useState(() => {
    return localStorage.getItem('pushNotificationsEnabled') === 'true';
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    checkExistingSubscription().then(exists => {
      if (exists) {
        setIsSubscribed(true);
        localStorage.setItem('pushNotificationsEnabled', 'true');
      }
      setIsChecking(false);
    }).catch(() => {
      setIsChecking(false);
    });
  }, []);

  const subscribe = async () => {
    setIsLoading(true);
    try {
      const subscription = await subscribeToPush();
      if (subscription) {
        console.log('Enviando suscripción al backend:', subscription.endpoint);
        await sendSubscriptionToBackend(subscription);
        console.log('Suscripción registrada exitosamente');
        setIsSubscribed(true);
        localStorage.setItem('pushNotificationsEnabled', 'true');
      } else {
        console.log('No se obtuvo suscripción (permiso denegado o error)');
      }
    } catch (error) {
      console.error('Error subscribing to push:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return { subscribe, isSubscribed, isLoading, isChecking };
}
